import { render, staticRenderFns } from "./ProductIdentitySection.vue?vue&type=template&id=6be49d54&"
import script from "./ProductIdentitySection.vue?vue&type=script&lang=js&"
export * from "./ProductIdentitySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports